import React from "react";
import Loader from "../../Loader/Loader";
import "./styles.css";

import {
  filterFreeTicketsRates,
  getTicketPriceConsideringFreeTickets,
  filterDiscountRates,
  priceFormat,
  getFreeTickets,
  roundedPrice,
} from "../../../utils/calculateDiscountAndCredits";
import DreamHomeBanner from "./dream-home-banner";
import FirstPrizeIcon from "./first-prize-icon";
import SecondPrizeIcon from "./second-prize-icon";

const labelsClassNames = {
  "MOST POPULAR": "most-popular",
  "LOWEST TICKET PRICE": "lowest-ticket-price",
};

const DoublePrizeTicketCard = ({
  type,
  ticketBundle,
  activeTicket,
  loading,
  onClick,
  raffles,
  isExpired,
  theme,
  label,
  result,
  ticketsCount,
  bonusDraw,
}) => {
  const discountsMapText = {
    15: "2 for 1",
    25: "3 for 1",
    50: "4 for 1",
  };
  const discountTicketsMapText = {
    15: "50",
    25: "150",
    50: "500",
  };

  const oldMapPrice = {
    "£10": "",
    "£25": "£75",
    "£50": "£150",
    "£100": "£400",
  };
  const bonusDrawId = bonusDraw && bonusDraw._id ? bonusDraw._id : null;
  // START OF API
  // const getTotalPrice = () => {
  //   const actualDiscount = filterDiscountRates(
  //     result.discountRates,
  //     ticketsCount
  //   );
  //   let price = actualDiscount
  //     ? ticketsCount * actualDiscount.newPrice
  //     : ticketsCount * result.prize.ticketPrice;
  //   return priceFormat(Math.ceil(price));
  // };
  const getTotalPrice = () => {
    const price = ticketBundle.price * ticketBundle.tickets;
    return priceFormat(Math.ceil(price));
  };

  const getTicketsCount = () => {
    let freeTickets = 0;
    const freeTicketsRates = getFreeTickets(
      result.prize,
      result.generalSettings
    );
    const actualFreeTicketsObject = filterFreeTicketsRates(
      freeTicketsRates,
      ticketBundle.tickets,
    );
    if (actualFreeTicketsObject) {
      freeTickets = actualFreeTicketsObject.extra;
    }
    return freeTickets + ticketBundle.tickets;
  };

  const totalCost = getTotalPrice();

  // END OF API
  const isDoublePrize = raffles.length > 1;
  const handleTitle = (bundle) => {
    // example  £2m Draw x 2,000 tickets
    if (raffles.length > 1) {
      const firstPrize = raffles[0];
      const secondPrize = raffles[1];
      const firstPrizeTitle = firstPrize.bundleTitle
        ? firstPrize.bundleTitle
        : firstPrize.title;
      const secondPrizeTitle = secondPrize.bundleTitle
        ? secondPrize.bundleTitle
        : secondPrize.title;

      const firstPrizeName = `${firstPrizeTitle} x ${getTicketsCount()} tickets`;
      const secondPrizeName = `${secondPrizeTitle} x ${getTicketsCount()} tickets`;
      return (
        <React.Fragment>
          <p className="details-rows">
            <span className="details-row">{firstPrizeName}</span>
          </p>
          <p className="details-rows">
            <span className="details-row">{secondPrizeName}</span>
          </p>
        </React.Fragment>
      );
    } else if (raffles.length === 1) {
      return (
        <>
          {/* £2m Draw x 2,000 tickets */}
          <p className="details-rows">
            <span className="details-row">{`${getTicketsCount()} tickets`}</span>
            <span className="details-row discount-tickets">{`${discountTicketsMapText[bundle]} tickets`}</span>
          </p>
        </>
      );
    } else {
      return <p>Raffle Title</p>;
    }
  };
  const handlePagediscountTitle = () => {
    return (
      <>
        <p>
          {`${getTicketsCount()} ${raffles[0].title.replace(
            "Cash Draw",
            ""
          )} tickets`}{" "}
        </p>
      </>
    );
  };

  const getBannerDetails = (prize) => {
    try {
      if (!prize) {
        return {
          title: "PRIZE",
          subtitle: "DREAM HOME",
        };
      }
      let prizeTitle = prize.bundleTitle ? prize.bundleTitle : prize.title;
      let title = prizeTitle ? prizeTitle.split(" ")[0].toUpperCase() : "PRIZE";
      let subtitle = prizeTitle
        ? prizeTitle.split(" ").slice(1).join(" ").toUpperCase()
        : "DREAM HOME";
      let array = prizeTitle ? prizeTitle.split(" ").slice(0, 2) : [];
      if (!array.length || array.length <= 1) {
        return {
          title: "PRIZE",
          subtitle: "DREAM HOME",
        };
      }
      return {
        title: title,
        subtitle: subtitle,
      };
    } catch (err) {
      return {
        title: "PRIZE",
        subtitle: "DREAM HOME",
      };
    }
  };

  const labelClassName = label ? labelsClassNames[label] : "";
  const banner1Details = getBannerDetails(raffles[0]);
  const banner2Details = getBannerDetails(raffles[1]);

  const getTicketPrice = () => {
    // const actualDiscount = filterDiscountRates(
    //   result.discountRates,
    //   ticketsCount
    // );
    // let price = actualDiscount
    //   ? ticketsCount * actualDiscount.newPrice
    //   : ticketsCount * result.prize.ticketPrice;
    // const tiketCost = (price * 100) / getTicketsCount() / 2;
    // return Math.round(tiketCost - 0.2);
    const price = ticketBundle.price * ticketBundle.tickets;
    const tiketCost = (price * 100) / getTicketsCount();
    return Math.round(tiketCost - 0.2);
  };

  return (
    <div
      className={[
        "ticket-card",
        ticketBundle.discount === 50 ? "premium" : "small",
        theme === "light" ? "ticket-card_white" : "ticket-card_green",
        labelClassName,
        isDoublePrize ? "double" : "",
      ].join(" ")}
      onClick={() => {
        if (!loading && !isExpired) {
          onClick({
            numOfTickets: ticketBundle.tickets,
            prizeType: "raffle",
            tickets: getTicketsCount(),
            bonusDraw: bonusDrawId,
          })();
        }
      }}
    >
      <div className="ticket-card__grid">
        <div className="ticket-card-header">
          <div className="header-prizes-block">
            <div className="prize-item">
              <FirstPrizeIcon />
              <DreamHomeBanner
                title={banner1Details.title}
                subtitle={banner1Details.subtitle}
              />
              <p>x {getTicketsCount()} tickets</p>
            </div>
            <div className="vertical-divider"></div>
            <div className="prize-item">
              <SecondPrizeIcon />
              <DreamHomeBanner
                title={banner2Details.title}
                subtitle={banner2Details.subtitle}
              />
              <p>x {getTicketsCount()} tickets</p>
            </div>
          </div>
        </div>
        <span className="ticket-price">
          Only {getTicketPrice()}p per ticket
        </span>
        <div className="header-divider"></div>
        {/* <div className='details'>
          {isDoublePrize
            ? handleTitle(ticket)
            : type === 'pagediscount'
            ? handlePagediscountTitle(ticket)
            : handleTitle(ticket)}
        </div> */}
        <div className="ticket-card__main">
          <div className="price">
            {/* {  <p className='discounted'> {totalCost}</p>} */}
            {/* <p className={isDiscount ? '' : 'no-discount'}>
            £{calculateDiscountPrice(ticket)}
          </p> */}
            {/* <p className="discounted">{oldMapPrice[totalCost]}</p> */}
            <p className={"no-discount"}>{totalCost}</p>
            {/* <p className='per-ticket'>{`${pricePerTicket} per ticket`}</p> */}
          </div>
          <button disabled={loading || isExpired} className="ticket-card__btn">
            {loading && activeTicket === ticketBundle.tickets ? (
              <>
                <Loader text="adding..." />
              </>
            ) : (
              <>Buy now</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoublePrizeTicketCard;
